import React from "react"
import { cn } from "./cn"

// Tailwind replacements for react-bootstrap form controls. Thin, styled native
// elements (not a Form.Group abstraction) — matches the look of the existing
// components/components/input.js fields.

const CONTROL =
  "block w-full rounded-md border-gray-300 shadow-xs sm:text-sm placeholder-gray-400 focus:border-integria-green focus:ring-integria-green disabled:cursor-not-allowed disabled:bg-gray-50"

export function Input({ className = "", type = "text", isInvalid = false, ...props }) {
  return (
    <input
      type={type}
      className={cn(CONTROL, isInvalid && "border-red-400 ring-1 ring-red-400", className)}
      {...props}
    />
  )
}

export function Textarea({ className = "", rows = 3, isInvalid = false, ...props }) {
  return (
    <textarea
      rows={rows}
      className={cn(CONTROL, isInvalid && "border-red-400 ring-1 ring-red-400", className)}
      {...props}
    />
  )
}

export function Select({ className = "", isInvalid = false, children, ...props }) {
  return (
    <select
      className={cn(CONTROL, isInvalid && "border-red-400 ring-1 ring-red-400", className)}
      {...props}
    >
      {children}
    </select>
  )
}

export function Label({ className = "", children, ...props }) {
  return (
    <label className={cn("block text-sm font-medium text-gray-700 mb-1", className)} {...props}>
      {children}
    </label>
  )
}

// InputGroup — a flex row that visually joins an addon (e.g. "$", "%", "ml") to
// a control. Kept deliberately simple (no Bootstrap-style border collapsing);
// the addon and control each carry their own rounded border.
export function InputGroup({ className = "", children, ...props }) {
  return (
    <div className={cn("flex items-stretch gap-1", className)} {...props}>
      {children}
    </div>
  )
}

export function InputGroupText({ className = "", children, ...props }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border border-gray-300 bg-gray-50 px-3 text-sm text-gray-500",
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}

InputGroup.Text = InputGroupText
